/* This file was automatically generated - please modify the template not this file! */

import * as React from "react";

import { ReadonlyCustomReferralForm } from "@teamprevent/common/questionnaires/components/referralForm/ReadonlyCustomReferralForm";

import { DashboardCaseType } from "../../../dashboard/model";
import { ReadonlyPpqForm } from "../../../Ppq/components/ReadonlyPpqForm";
import { WritableReferralForm } from "../../../referral/components/WritableReferralForm";
import { ReadonlyPhysiotherapyReferralForm } from "../../../physiotherapy/components/ReadonlyPhysiotherapyReferralForm";

import { ReadonlyGenericCaseForm } from "../../../genericCase/components/ReadonlyGenericCaseForm";

import ManageAssignedUsers from "./manageAssignedUsers/ManageAssignedUsers";

import { All } from "./All";
import { Detail } from "./Detail";
import Edit from "./Edit";
import Create from "./Create";
import { BaseItemExtensions } from "./BaseItemExtensions";
import { BaseRootExtensions } from "./BaseRootExtensions";

import { Fragment } from "redux-little-router";

interface Props {
    include?: DashboardCaseType;
}

const Base: React.FunctionComponent<Props> = (props: Props) => {
    return (
        <div className="oh-case">
            <Fragment forRoute="/" withConditions={l => l.params.ohCaseId === undefined}>
                <div>
                    <All include={props.include} />
                    <Create />
                    <BaseItemExtensions />
                </div>
            </Fragment>
            <Fragment forRoute="/:ohCaseId/matchedReferral" withConditions={l => l.params.ohCaseId !== undefined}>
                <div>
                    <ReadonlyCustomReferralForm api="/api/case/matchedReferral" documentBaseApi="/api/referral" />
                </div>
            </Fragment>
            <Fragment forRoute="/:ohCaseId/matchedPhysiotherapyReferral" withConditions={l => l.params.ohCaseId !== undefined}>
                <div>
                    <ReadonlyPhysiotherapyReferralForm api="/api/case/matchedPhysiotherapyReferral" documentBaseApi="/api/physiotherapy" />
                </div>
            </Fragment>
            <Fragment forRoute="/:ohCaseId/ppq" withConditions={l => l.params.ohCaseId !== undefined}>
                <div>
                    <ReadonlyPpqForm />
                </div>
            </Fragment>
            <Fragment forRoute="/:ohCaseId/genericCaseForm" withConditions={l => l.params.ohCaseId !== undefined}>
                <div>
                    <ReadonlyGenericCaseForm />
                </div>
            </Fragment>
            <Fragment forRoute="/:ohCaseId/referReferralAgain" withConditions={l => l.params.ohCaseId !== undefined}>
                <WritableReferralForm />
            </Fragment>
            <Fragment forRoute="/:ohCaseId/manageAssignedUsers" withConditions={l => l.params.ohCaseId !== undefined}>
                <div>
                    <ManageAssignedUsers />
                </div>
            </Fragment>
            <Fragment forRoute="/:ohCaseId">
                <div>
                    <Detail />
                    <Edit />
                    <BaseRootExtensions />
                </div>
            </Fragment>
        </div>
    );
};

export default Base;
